import { Grid, Typography } from '@mui/material';
import { ExternalIdentityVerificationAttributeSelect } from '@occc-app/routes/Audience/components/ExternalIdentityVerification/ExternalIdentityVerificationAttributeSelect';
import { useConfig } from '@occc/config';
import { getDomainForProvider } from './utils';
import { AudienceFormValuesPaths } from '../../types';

const getFormFieldName = (key: 'inAll' | 'inAny' | 'notInAll') =>
  `externalIdentityVerification.${key}.verificationAttributes` satisfies AudienceFormValuesPaths;

export const formPrefix = 'externalIdentityVerification';

export const ExternalIdentityVerificationContent = () => {
  const { config } = useConfig();

  return (
    <div>
      <Typography paragraph variant='subtitle1'>
        {getDomainForProvider(config.externalIdentityVerification?.provider)} Verified Community
      </Typography>

      <Grid container rowSpacing={2} columnSpacing={2}>
        <Grid item xs={12} md={6}>
          <ExternalIdentityVerificationAttributeSelect
            name={getFormFieldName('inAll')}
            label='In all these communities'
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <ExternalIdentityVerificationAttributeSelect
            name={getFormFieldName('inAny')}
            label='In any of these communities'
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <ExternalIdentityVerificationAttributeSelect
            name={getFormFieldName('notInAll')}
            label='Not in any of these communities'
          />
        </Grid>
      </Grid>
    </div>
  );
};
